export default "__VITE_ASSET__DeE7NWVc__"